import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Milling } from '../../../models/cutting/cutting-panel-outline.model';
import { ApiLinks } from '../../cutting-panel-list/csl.api-links';

export interface IMillingsDialogData {
  userId: number;
  millings: Milling[];
}

@Component({
  templateUrl: './millings-dialog.component.html',
  styleUrls: ['./millings-dialog.component.scss'],
})
export class MillingsDialogComponent {
  columns = ['selection', 'icon', 'name', 'description'];

  selection = new SelectionModel<Milling>(false);

  constructor(@Inject(MAT_DIALOG_DATA) public data: IMillingsDialogData) {}

  getIconLink(millingId: number): string {
    return `${ApiLinks.millingsForClient}/${millingId}/icon?userId=${this.data.userId}`;
  }
}
